<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ $t('Welcome') }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">{{ $t("Home") }}</router-link>
              </li>
              <li class="breadcrumb-item active"> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <span v-if="!isLoadedEverything">{{ loader }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as Roles from '../definitions/Roles';

export default {
  data() {
    return {
      loader: 'Loading data, you will be redirected soon..',
    }
  },
  watch: {
    isLoadedEverything(newValue) {
      if (newValue) {
        this.resolveLandingPage();
      }
    },
  },
  computed: {
    isLoadedEverything() {
      if (!this.$store.getters['api/isLoadedUserDashboards']) {
        return false;
      }

      if (!this.$store.getters['currentUserLoaded']) {
        return false;
      }

      return true;
    },
  },
  methods: {
    resolveLandingPage() {
      if (process.env.VUE_APP_ENV === 'prod') {
        this.$router.push({name: 'Admin Chat'});
      } else {
        const currentUser = this.$store.getters['currentUser'];

        if (currentUser.type === Roles.ADMIN_CHAT_MANAGER) {
          this.$router.push({name: 'Admin Chat'});
        }

        if (currentUser.type === Roles.ADMIN) {
          this.$router.push({name: 'Users'});
        }

        this.loader = 'There is no suitable welcome page for your role yet.'
      }
    },
  },
  mounted() {
    this.$store.dispatch('loadCurrentUser').then(() => {
      this.resolveLandingPage();
    });
  },
}
</script>
